var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['customfield-open', { target: _vm.target && _vm.target.input, open: _vm.open }],on:{"click":_vm.click}},[_c('BaseTooltip',{attrs:{"title":"Add Custom Field"}},[_c('span',{staticClass:"btn"},[_vm._v("{ }")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }